// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { DepositAttestation } from '@daml.js/utility-bridge-v0/lib/Utility/Bridge/V0/Attestation/Deposit/module';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { ContractId } from '@daml/types';
import { BridgeAgreement } from '@daml.js/utility-bridge-v0/lib/Utility/Bridge/V0/Agreement/Bridge';
import { StoredNonces } from '@daml.js/utility-bridge-v0/lib/Utility/Bridge/V0/Nonce/Nonce';

const useCreateDepositAttestation: () => UseMutationResult<
  [ContractId<DepositAttestation>, string] | undefined,
  string,
  {
    bridgeAgreementCid: ContractId<BridgeAgreement>,
    recipient: string,
    payload: string,
    messageHash: string,
    attestation: string,
    reference: string,
    usedNoncesCid: ContractId<StoredNonces>,
  }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['createDepositAttestation', ledgerApi],
    mutationFn: async ({
      bridgeAgreementCid,
      recipient,
      payload,
      messageHash,
      attestation,
      reference,
      usedNoncesCid,
    }) => {
      return ledgerApi.createDepositAttestation(
        bridgeAgreementCid,
        recipient,
        payload,
        messageHash,
        attestation,
        reference,
        usedNoncesCid,
      );
    },
  });
};

export default useCreateDepositAttestation;
